import { CREDITED_TO_LABEL } from '@/lib/account-lead-history';

/**
 * "Credited to" on the deal / quote / invoice detail pages (owner 2026-10-25).
 *
 * `creditedTo` is the lead who earns targets and commission credit for this
 * document: its own override when set, else the company's lead ON THE
 * DOCUMENT'S DATE from the account lead history (deal closing date, quote
 * issue date, invoice bill date). It differs from the account lead shown
 * beside it only when the company's lead changed after that date.
 *
 * Renders as one grid cell (`dt` + `dd`) inside the page's own `<dl>`, so it
 * sits beside the Account lead item. Nothing renders when:
 * - `creditedTo` is `undefined` (an older API that does not report it);
 * - it names the same person as the account lead shown;
 * - it is `null` and no account lead is shown either (both say nobody).
 * `null` beside a shown lead means the document's date falls in a gap in the
 * history, so the cell reads `—`.
 */
export function CreditedTo({
  creditedTo,
  accountLeadId,
  labelClassName = 'text-xs text-fg-muted',
}: {
  creditedTo: { id: number; name: string } | null | undefined;
  accountLeadId: number | null | undefined;
  /** The page's own `dt` styling, so the cell matches its neighbours. */
  labelClassName?: string;
}) {
  if (creditedTo === undefined) return null;
  if (creditedTo === null) {
    if (accountLeadId === null || accountLeadId === undefined) return null;
  } else if (creditedTo.id === accountLeadId) {
    return null;
  }

  const name = creditedTo ? creditedTo.name.trim() || `Staff #${creditedTo.id}` : null;

  return (
    <div className="min-w-0">
      <dt className={labelClassName}>{CREDITED_TO_LABEL}</dt>
      <dd className="mt-0.5 text-sm text-fg-secondary [overflow-wrap:anywhere]">
        {name ?? <span className="text-fg-subtle">—</span>}
      </dd>
    </div>
  );
}
